import React, { Component } from 'react';
import { Redirect } from 'react-router-dom';
import axios from 'axios';
import _ from 'lodash';
import { API_URL } from '../../partials/Globals';
import Errors from '../../partials/Errors';

export default class AddProject extends Component {
    state = {
        errors: '',
        message: '',
        group: {
            name: ''
        },
        projects: {
            id: '',
            title: ''
        },
        project: {
            project_id: '', 
            shares: '',
            share_price: '',
            group_share_cut: '',
            start_date: '',
            end_date: ''
        },
        redirectBack: false
    }

    constructor(props) {
        super(props);

        this.fetch = this.fetch.bind(this);
        this.submit = this.submit.bind(this);
        this.inputChange = this.inputChange.bind(this);
    }

    componentDidMount() {
        this.fetch();
    }

    fetch() {
        axios.get(API_URL+'/admin/groups/'+this.props.match.params.group_id)
            .then(response => {
                this.setState({ group: response.data }, function() {
                    // Väntar på att gruppen hämtats innan det går att filtrera
                    axios.get(API_URL+'/admin/projects')
                        .then(response => {
                            var projects = response.data;
                            // Filtrera bort projekt som redan är kopplade till gruppen
                            if (projects.length > 0 && this.state.group.projects.length > 0) {
                                const ids = _.map(this.state.group.projects, 'id'); 
                                projects = _.filter(projects, (project) => !_.includes(ids, project.id)); 
                            }
                            this.setState({ projects: projects });
                        });
                });
            });

    }

    inputChange(event) {
        const target = event.target;
        const value = target.type === 'checkbox' ? target.checked : target.value;
        const name = target.name;

        this.setState({ project: {...this.state.project, [name]: value } });
    }

    submit(event) {
        event.preventDefault();

        axios.post(API_URL+'/admin/groups/'+this.props.match.params.group_id+'/projects/attach', {
            project_id: this.state.project.project_id,
            shares: this.state.project.shares,
            share_price: this.state.project.share_price,
            group_share_cut: this.state.project.group_share_cut,
            start_date: this.state.project.start_date,
            end_date: this.state.project.end_date
        })
        .then(response => {
            this.setState({ redirectBack: true });
        })
        .catch(error => {
            // Valideringsfel
            if (error.response && error.response.status === 422) {
                this.setState({ errors: error.response.data }); 
            }
            // Annat fel
            if (error.response && error.response.status === 400) {
                this.setState({ errors: {1: 'Någonting gick fel, var god försök igen.'} })
            }
        });
    }

    render() {
        const { projects, project } = this.state;

        if (this.state.redirectBack) {
            return <Redirect to={ `/superadmin/groups/edit/${ this.props.match.params.group_id }` } message="Projektet har sparats!" />
        }

        return (
            <div>
                <div className="top">
                    <div className="col-12">
                        <button className="back" onClick={ this.props.history.goBack }>Tillbaka</button>
                    </div>
                </div>

                <Errors errors={ this.state.errors } />

                <div className="container">
                    <div className="content">
                        <h1>Lägg till projekt till { this.state.group.name }</h1>

                        <form onSubmit={ this.submit }>
                            { this.state.projects &&
                                <div>
                                    <label>Projekt</label>
                                    <select name="project_id" value={ project.project_id } onChange={ this.inputChange }>
                                        <option>Välj</option>
                                        { Object.keys(projects).map(function(key) {
                                            return <option key={ key } value={ projects[key].id }>{ projects[key].title }</option>
                                        }) } 
                                    </select>
                                </div>
                            }
                            <label>Antal andelar</label>
                            <input type="number" name="shares" required value={ project.shares } onChange={ this.inputChange } />
                            <label>Styckpris</label>
                            <input type="number" name="share_price" required value={ project.share_price } onChange={ this.inputChange } />
                            <label>Gruppens förtjänst per såld andel</label>
                            <input type="number" name="group_share_cut" required value={ project.group_share_cut } onChange={ this.inputChange } />
                            <label>Startdatum (YYYY-MM-DD)</label>
                            <input type="text" name="start_date" required value={ project.start_date } onChange={ this.inputChange } />
                            <label>Slutdatum (YYYY-MM-DD)</label>
                            <input type="text" name="end_date" required value={ project.end_date } onChange={ this.inputChange } />

                            <input className="button purple" type="submit" value="Spara" />
                        </form>
                    </div>
                </div>
            </div>
        )
    }
}



// WEBPACK FOOTER //
// ./src/components/superadmin/Group/AddProject.js